import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { ReactNode, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { MetaContext, MetaContextPayload } from '../../../../context/metaContext';
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { zohoIntegrationList } from '../../../../models/axiosModel';
import globalStyles from "../../../../assets/styles/global.module.scss";
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import tempStyles from "../../../../assets/styles/componentStyles/accountInformationCard.module.scss";
import IconsColor from '../../../utility/iconsColor';
import GlobalButton from '../../../utility/globalButton/button';
import cardStyles from './../../../../assets/styles/componentStyles/accountInformationCard.module.scss'
import { primaryColor } from '../../../../utils/colors';
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup';
import agent from '../../../../services/api';
import { hasAIChatbotManageAccess } from '../../../../utils/constants';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

export interface integrationFields {
    key: string,
    value: any,
    iconName: string,
}

const ViewZohoIntegration = () => {

    const {
        showFacebookIntegrationDetails,
    } = useContext(MetaContext) as MetaContextPayload;

    const {
        getZohoIntegrations,
        zohoIntegrations,
    } = useContext(IntegrationContext) as IntegrationContextPayload;

    const navigate = useNavigate()
    const { setFlagLoading, userDetail, handleError, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [zohoIntegrationDetails, setZohoIntegrationDetails] = useState<zohoIntegrationList[] | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);

    const breakPoints = {
        smallScreen: useMediaQuery('(max-width : 600px) and (min-width : 0px)'),
        tabletScreen: useMediaQuery('(max-width : 900px) and (min-width : 600px)'),
        laptopScreen: useMediaQuery('(max-width : 1600px) and (min-width : 900px)'),
    }

    const zohoIntegrationFields: integrationFields[] = [
        {
            key: "Zoho User",
            value: zohoIntegrationDetails?.[0]?.zoho_user_name,
            iconName: "workspace",
        },
        {
            key: "Zoho User Email",
            value: zohoIntegrationDetails?.[0]?.zoho_user_email,
            iconName: "profile",
        },
        {
            key: "Phone Number",
            value: zohoIntegrationDetails?.[0]?.zoho_integration_organization_data?.[0]?.zoho_integration_organization_url ? JSON.parse(zohoIntegrationDetails[0].zoho_integration_organization_data[0].zoho_integration_organization_url).phoneNumber : "",
            iconName: "phoneNumber",
        }
    ]

    useLayoutEffect(() => {
        (async () => {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            const res = await getZohoIntegrations()
            if (!(res.status)) {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        })()
    }, []);

    useEffect(() => {
        if (searchParams.has('id')) {
            if (zohoIntegrations && zohoIntegrations.length > 0) {
                let id = Number(searchParams.get('id'))
                let integration = zohoIntegrations.filter((zohoIntegration: zohoIntegrationList) => zohoIntegration.zoho_integration_id == id)
                if (integration.length > 0) {
                    setZohoIntegrationDetails(integration)
                } else {
                    navigate('/channels')
                }
            }
        } else {
            navigate('/channels')
        }
    }, [zohoIntegrations]);

    const deleteZohoIntegration = async () => {
        if (zohoIntegrationDetails) {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            const zoho_integration_id = zohoIntegrationDetails?.[0]?.zoho_integration_id;
            const zoho_integration_organization_id = zohoIntegrationDetails?.[0]?.zoho_integration_organization_data?.[0]?.zoho_integration_organization_id;

            const res = await agent.deleteZohoIntegration.delete((zoho_integration_id).toString(), zoho_integration_organization_id);
            if (res.status) {
                showSuccess("Integration deleted successfully!")
                navigate('/channels');
            } else {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
        }
    }

    const renderZohoIntegrationFields = (field: integrationFields, ind: number): ReactNode => {
        return (
            <Grid item key={ind}>
                <Grid container className={globalStyles.createChatbotContainer} gap={"4px"}>
                    <Grid item className={cardStyles.objectKeyStyle}>
                        <Grid container className={`${globalStyles.createChatbotContainer} ${globalStyles.gapTwo}`}>
                            <IconsColor iconName={field.iconName} width="24px" height="24px" fillColor={primaryColor} />
                            {field.key}&nbsp;
                        </Grid>
                    </Grid>

                    <Grid item className={cardStyles.genericValueStyle}>{field.value}</Grid>
                </Grid>
            </Grid>
        );
    }

    const innerHeight = breakPoints.smallScreen ? (window.innerHeight - 90) : breakPoints.tabletScreen ? (window.innerHeight - 100) : breakPoints.laptopScreen ? (window.innerHeight - 100) : (window.innerHeight - 110);
    const integrationViewInnerHeight = breakPoints.smallScreen ? (window.innerHeight - 110) : breakPoints.tabletScreen ? (window.innerHeight - 100) : breakPoints.laptopScreen ? (window.innerHeight - 120) : (window.innerHeight - 140);
    return (
        <>
            <Grid item
                className={showFacebookIntegrationDetails == false ? `${globalStyles.fullwidth} ${styles.integrationDefaultView}` : `${globalStyles.fullwidth} ${styles.integrationView}`}
                height={showFacebookIntegrationDetails == false ? `${innerHeight}px !important` : `${integrationViewInnerHeight}px !important`}
            >
                <Grid container>
                    {zohoIntegrationDetails &&
                        <Grid item className={globalStyles.fullwidth} xs={12} lg={12} xl={12}>
                            <Grid container gap={3} >
                                <Grid item className={globalStyles.fullwidth}>
                                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapLength} `}>
                                        <Grid item xs={12}>
                                            <Grid container className={globalStyles.flexColumn}>
                                                <Grid item className={tempStyles.header}>
                                                    <Grid container className={globalStyles.spaceAlignmentCenter}>

                                                        <Grid item className={globalStyles.displayFlex}>
                                                            <Grid container>
                                                                <Grid item className={`${globalStyles.displayFlex} ${tempStyles.rightMargin}`} >
                                                                    <IconsColor iconName="zoho" width="20px" height="20px" />

                                                                </Grid>
                                                                <Grid item className={tempStyles.headerText}>{'Zoho'}</Grid>
                                                            </Grid>
                                                        </Grid>
                                                        {hasAIChatbotManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                                            <Grid item>
                                                                <GlobalButton
                                                                    buttonText={"Delete"}
                                                                    className="deleteIntegrationButton"
                                                                    onClick={() => { setShowDeleteConfirmation(true) }}
                                                                    startIcon={<IconsColor iconName="DeleteIcon" fillColor={primaryColor} height="16" width="16" />}
                                                                />
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Divider className={tempStyles.slackZohoAccSetUpDivider} />
                                            </Grid>
                                        </Grid>
                                        {zohoIntegrationFields.map((field: integrationFields, ind: number) => {
                                            return renderZohoIntegrationFields(field, ind);
                                        })}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {showDeleteConfirmation &&
                        <GlobalDeletePopup
                            deleteDescription={`Are you sure you want to delete ${zohoIntegrationDetails?.[0]?.zoho_user_name} - ${zohoIntegrationDetails?.[0]?.zoho_user_email} Zoho account`}
                            open={showDeleteConfirmation}
                            onClose={() => { setShowDeleteConfirmation(false) }}
                            onDelete={() => {
                                deleteZohoIntegration()
                                setShowDeleteConfirmation(false)
                            }}
                        />
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default ViewZohoIntegration
